import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

function ReviewSlider({ reviews = [], baseUrl = "" }) {
  return (
    <section className="ser_v_araeea manngess pt_top_0 reviewss">
      <div className="container hm_arrowss">
        {reviews?.length > 0 && (
          <div className="al_sec_ctxt mb-2">
            <h2 className="sm_tetx_sizess">Reviews</h2>
          </div>
        )}

        <div className="swiper-nav-btns">
          <div className="swiper-button-prev custom-prev"></div>
          <div className="swiper-button-next custom-next"></div>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          navigation={{
            prevEl: ".custom-prev",
            nextEl: ".custom-next",
          }}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {reviews?.map((review, i) => (
            <SwiperSlide key={i}>
              <div className="tsty_mlsss">
                {/* <h4>{review.title}</h4> */}
                <p>{review.description}</p>
                <div className="queststs">
                  <img src="/images/questts.png" alt="quote" />
                </div>
                <div className="user_bothhhs">
                  <div className="user_mgs">
                    <img
                     src={
                          review.profile
                            ? `${baseUrl}${review.profile}`
                            : "/images/user_dh.png"
                        }
                      
                      alt={`${review?.name}`}
                    />
                  </div>
                  <div className="cont_txt_mgs">
                    <h5>{review.name}</h5>
                    <p>
                      {[...Array(5)].map((_, index) => (
                        <i
                          key={index}
                          className={`fa ${
                            index < review.rating ? "fa-star" : "fa-star-o"
                          }`}
                        ></i>
                      ))}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default ReviewSlider;
